/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: MLAuthStandalone.ts
 * Project: mle-client-n
 * Committed last: 2022/11/10 @ 155
 * ---
 * Description:
 */

import {StandaloneFeature} from "../../common/StandaloneFeature";
import {mleDomainGqlClient} from "../../../../api/domain";
import {ML_LOGIN} from "../../../../api/domain/mutations.gql";
import {StandaloneFeatures} from "../../../../components/App";

export const MLAUTH_STANDALONE = "MyLabelAuthStandalone";

/**
 * Esegue una chiamata alle api mylabel autenticandosi prima. Se l'autenticazione fallisce restituisce undefined, altrimenti il risultato della richiesta. Nel caso sia necessario inserire le credenziali, triggera la visualizzazione del dialogo di inserimento.
 * Funge anche da protettore per eventuali eccezioni
 * @param fun Funzione da eseguire
 */
export const mlAuthSecured_standalone = async <T>(fun: () => Promise<T>): Promise<T | undefined> => {
    // Load credentials
    const impl = StandaloneFeatures.getByName<MyLabelAuthStandalone>(MLAUTH_STANDALONE);

    // Perform auth on service
    const result = await impl.performAuthOnService();

    if (!result) return undefined;

    let data;

    try {
        data = await fun();
    } catch (e) {
        data = undefined;
    }
    return data;
}

export class MyLabelAuthStandalone extends StandaloneFeature<void> {
    public static __usr_key = 'ml_usr';
    public static __usr_pwd = 'ml_pwd';

    constructor() {
        super(MLAUTH_STANDALONE);
    }

    /**
     * Rimuove le credenziali salvate dalla localstorage
     */
    public removeConfiguration() {
        window.localStorage.removeItem(MyLabelAuthStandalone.__usr_key);
        window.localStorage.removeItem(MyLabelAuthStandalone.__usr_pwd);
    }

    /**
     * Scrive le credenziali nello storage
     * TODO: Migliorare sicurezza tramite crittografia asimmetrica gestita dal server
     */
    public writeToStorage(username: string, password: string) {
        window.localStorage.setItem(MyLabelAuthStandalone.__usr_key, username);
        window.localStorage.setItem(MyLabelAuthStandalone.__usr_pwd, password);
    }

    /**
     * Effettua l'autenticazione sul servizio
     */
    public async performAuthOnService(): Promise<boolean> {
        const username = window.localStorage.getItem(MyLabelAuthStandalone.__usr_key);
        const password = window.localStorage.getItem(MyLabelAuthStandalone.__usr_pwd);

        try {
            await mleDomainGqlClient.mutate({
                mutation: ML_LOGIN,
                variables: {
                    username: username,
                    password: password
                }
            });

            return true;
        } catch (e) {
            console.error("Impossibile autenticarsi al servizio MyLabel. ");
            console.error(e);
        }

        return false;
    }

    /**
     * Controlla se è necessario il salvataggio delle credenziali o sono già
     * state salvate in locale
     */
    public requiresCredentials(): boolean {
        const key = window.localStorage.getItem(MyLabelAuthStandalone.__usr_key);
        const pwd = window.localStorage.getItem(MyLabelAuthStandalone.__usr_pwd);

        return !key || !pwd;
    }
}

export class MLAuthStandaloneInstanceManager {
    private static _instance?: MyLabelAuthStandalone;

    public static getInstance() {
        if (!MLAuthStandaloneInstanceManager._instance) MLAuthStandaloneInstanceManager._instance = new MyLabelAuthStandalone();

        return MLAuthStandaloneInstanceManager._instance;
    }
}